import { blue, grey } from "@mui/material/colors";
import { PickersDay } from "@mui/x-date-pickers";
import PropTypes from "prop-types";
import React from "react";

export default function CustomDay(props) {
  const { day } = props;
  const isOnDay = Math.random() >= 0.25;
  const isFutureDay = day > new Date();

  const [color] = (() => {
    if (isFutureDay) return ["#fff"];
    if (isOnDay) return [blue[200]];
    return [grey[300]];
  })();

  return (
    <PickersDay
      {...props}
      today={false}
      sx={{
        width: "22px",
        height: "22px",
        backgroundColor: `${color} !important`,
      }}
    />
  );
}

CustomDay.propTypes = {
  day: PropTypes.instanceOf(Date).isRequired,
  outsideCurrentMonth: PropTypes.bool,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  today: PropTypes.bool,
};

CustomDay.defaultProps = {
  outsideCurrentMonth: false,
  selected: false,
  disabled: false,
  today: false,
};
